$(function(){

    var checkedIds = [];

    var language = $('html').attr('lang');
    var lang = '';
    if(language !== 'en'){
        lang = "/" + language;
    }

    var successMessages = {
        'ru': 'Сообщение отправлено',
        'en': 'Message sent'
    };

    var errorMessages = {
        'ru': 'Произошла ошибка',
        'en': 'An error has occurred'
    };

    var deleteConfirm = {
        titles: {
            ru: 'Вы уверены?',
            en: 'Are you sure?'
        },
        descriptions: {
            ru: 'Вы не сможете вернуть его/их обратно!',
            en: 'You will not be able to recover this message(s)!'
        },
        button: {
            ru: 'Да, хочу удалить!',
            en: 'Yes, delete it!'
        },
        resultsSuccess: {
            ru: 'Готово!',
            en: 'Deleted!'
        },
        resultsError: {
            ru: 'Произошла ошибка',
            en: 'An error occurred'
        }

    };

    $(document).on('click', '.send-message', function(){
        var username = $(this).data('username');
        var id = $(this).data('id');
        if($(this).hasClass('reply-message-link')){
            $('#send-message-modal .twitter-typeahead').hide();
            $('#send-message-modal #message-title').val('RE: '+$(this).data('title'));
            var text = $('#msg-'+id+'-text').text();
            text = text.replace(/\s+/g,' ');
            $('#send-message-modal #message-text').val('{quote}'+text+'{quote}\n');
        }
        if(!username){
            console.log('No username provided');
        } else {
            $('#send-message-username').val(username);
            $('#send-message-to').text(username);
            $('#send-message-modal').modal('show');
        }
    });

    $(document).on('hidden.bs.modal', '#send-message-modal', function () {
        $('#send-message-modal .twitter-typeahead').show();
        $('#send-message-modal #message-title').val('');
        $('#send-message-modal #message-text').val('');
    });

    $(document).on('click', '#send-message', function(){
        var form = $('#send-message-form');
        var url = '/message/send';

        $('#send-message-modal').modal('hide');

        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(), // serializes the form's elements.
            dataType: "json",
            success: function(data)
            {
                var errMsg = '';
                if(data.status === 'success'){
                    swal(':)', successMessages[$('html').attr('lang')], 'success');
                } else {
                    if(data.errMsg){
                        errMsg = data.errMsg;
                        swal(errorMessages[$('html').attr('lang')], errMsg, 'error');
                    } else {
                        errMsg = errorMessages[$('html').attr('lang')];
                        swal(':(', errMsg, 'error');
                    }

                }
            }
        });
    });

    // Mark message read
    $(document).on('click', '.panel-heading', function(){
        var heading = $(this);
        var status = $(this).hasClass('unread');
        var title = $(this).find('h4 div');
        if(status === true && !title.hasClass('collapsed')){
            var id = title.data('target').split('-');
            var url = '/message/mark';
            $.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                data: {'id': id[1], 'action': 'read'},
                success: function(data){
                    if(data.status === 'success') {
                        heading.removeClass('unread');
                        heading.find('.sended-message-title').removeClass('unread');
                        $('#messages-count').trigger('check-messages');
                    }
                }
            });
        }
    });

    $(document).on('keyup', '#senders-filter', function(){
        var pos;
        var input = $(this).val();

        setTimeout(function(){
            $('.message-senders-list li').each(function(){
                var text = $(this).find('a').text();
                if (-1 < (pos = text.toLowerCase().indexOf(input))) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        }, 200);
    });

    // Checking messages
    $(document).on('click', '.message-checkbox', function(e){
        e.stopPropagation();
        var check = $(this).find('i');
        var block = $(this).closest('.message-header-block');
        var id = block.data('target').split('-')[1];
        if(check.hasClass('fa-square-o')){
            checkedIds.push(id);
            check.removeClass('fa-square-o').addClass('fa-check-square-o');
        } else {
            checkedIds.splice( $.inArray(id, checkedIds), 1 );
            check.removeClass('fa-check-square-o').addClass('fa-square-o');
        }

        var isButton = $('*').is('#delete-messages');
        console.log(isButton);

        if(checkedIds.length > 0){
            if(isButton){
                $('#delete-messages').find('b').text(checkedIds.length);
            } else {
                $('#messages-group').append('<button type="button" class="btn btn-danger" id="delete-messages">Delete (<b>'+checkedIds.length+'</b>)</button>');
            }
        } else {
            if(isButton){
                $('#delete-messages').remove();
            }
        }
    });

    // Deleting messages by one
    $(document).on('click', '.message-delete', function(e){
        e.stopPropagation();
        var icon = $(this);
        swal({
            title: deleteConfirm.titles[language],
            text: deleteConfirm.descriptions[language],
            type: "warning",
            showCancelButton: true,
            canselButtonText: 'Cancel',
            confirmButtonColor: "#DD6B55",
            confirmButtonText: deleteConfirm.button[language],
            closeOnConfirm: false
        }, function(){
            var heading = icon.closest('.panel-heading');
            var block = icon.closest('.message-header-block');
            var id = block.data('target').split('-')[1];
            var message = $('#message-'+id);
            var url = '/message/delete';
            $.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                data: {id: id},
                success: function(data){
                    if(data.status === 'success') {
                        $( block, message ).animate({
                            width: [ "toggle", "swing" ],
                            height: [ "toggle", "swing" ],
                            opacity: "toggle"
                        }, 2000, "linear", function() {
                            heading.remove();
                            message.remove();
                            $('#messages-count').trigger('check-messages');
                        });
                        swal("Ok", deleteConfirm.resultsSuccess[language], "success");
                    } else {
                        swal("", deleteConfirm.resultsError[language], "error");
                    }
                },
                error: function () {
                    swal("", deleteConfirm.resultsError[language], "error");
                }
            });

        });

    });

    // Mark message unread
    $(document).on('click', '.message-unread', function(e){
        e.stopPropagation();
        var heading = $(this).closest('.panel-heading');
        var block = $(this).closest('.message-header-block');
        var id = block.data('target').split('-')[1];
        var message = $('#message-'+id);
        var url = '/message/mark';
        $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            data: {id: id, action: 'unread'},
            success: function(data){
                if(data.status === 'success') {
                    heading.addClass('unread');
                    $('.sended-message-title').addClass('unread');
                    $('#messages-count').trigger('check-messages');
                } else {
                    swal("", errorMessages[language], "error");
                }
            },
            error: function () {
                swal("", errorMessages[language], "error");
            }
        });
    });

    $(document).on('click', '#delete-messages', function(e) {
        e.preventDefault();
        console.log(checkedIds);
        swal({
            title: deleteConfirm.titles[language],
            text: deleteConfirm.descriptions[language],
            type: "warning",
            showCancelButton: true,
            canselButtonText: 'Cancel',
            confirmButtonColor: "#DD6B55",
            confirmButtonText: deleteConfirm.button[language],
            closeOnConfirm: false
        }, function(){
            var url = '/message/delete';
            $.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                data: {id: checkedIds},
                success: function(data){
                    if(data.status === 'success') {
                        checkedIds = [];
                        $.pjax.reload({container:'#user-messages'});
                        $('#messages-count').trigger('check-messages');
                        swal("Ok", deleteConfirm.resultsSuccess[language], "success");
                    } else {
                        swal("", deleteConfirm.resultsError[language], "error");
                    }
                },
                error: function () {
                    swal("", deleteConfirm.resultsError[language], "error");
                }
            });

        });
    });

    $(document).on('click', '.action-delete-all-bot', function () {
        swal({
            title: deleteConfirm.titles[language],
            text: deleteConfirm.descriptions[language],
            type: "warning",
            showCancelButton: true,
            canselButtonText: 'Cancel',
            confirmButtonColor: "#DD6B55",
            confirmButtonText: deleteConfirm.button[language],
            closeOnConfirm: false,
            showLoaderOnConfirm: true
        }, function(){
            var url = '/message/delete';
            $.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                data: {id: 'bot'},
                success: function(data){
                    if(data.status === 'success') {
                        checkedIds = [];
                        $.pjax.reload({container:'#user-messages'});
                        $('#messages-count').trigger('check-messages');
                        swal("Ok", deleteConfirm.resultsSuccess[language], "success");
                    } else {
                        swal("", deleteConfirm.resultsError[language], "error");
                    }
                },
                error: function () {
                    swal("", deleteConfirm.resultsError[language], "error");
                }
            });

        });
    });

});